// @flow

import { css } from 'styled-components';
import { BREAK_MD, BREAK_XL } from './Width';

export const heights = (mobile: number | string, tablet?: number | string, desktop?: number | string) => css`
  height: ${typeof mobile === 'string' ? mobile : `${mobile}px`};

  ${tablet &&
    `@media print, screen and (min-width: ${BREAK_MD}px) {
      height: ${typeof tablet === 'string' ? tablet : `${tablet}px`};
    }`};

  ${desktop &&
    `@media print, screen and (min-width: ${BREAK_XL}px) {
      height: ${typeof desktop === 'string' ? desktop : `${desktop}px`};
    }`};
`;
